import { ConversionUtil } from "@mcleod/core";
import { AutogenModelDetentionControl, AutogenRowDetentionControl, RowDetentionControlFields } from "./autogen/AutogenModelDetentionControl";
import { LMEGeneralSettings } from "@mcleod/general";

export class ModelDetentionControl extends AutogenModelDetentionControl<RowDetentionControl> {
	constructor() {
		super(RowDetentionControl);
	}
}

export function getDetentionControlBoolean(field: keyof RowDetentionControlFields, valueIfNull: boolean = false): boolean {
    const result = getDetentionControlValue(field);
    if (typeof result === "string")
        return ConversionUtil.parseBoolean(result);
    return result ?? valueIfNull;
}

export function getDetentionControlValue(field: keyof RowDetentionControlFields): any {
    return LMEGeneralSettings.getSingleton().getDetentionControl()[field];
}

export class RowDetentionControl extends AutogenRowDetentionControl {
}